import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import watch from './attrs/watch'
import ListHeader from '@/components/ListHeader/Index'

export default {
    name: 'AgencyList',
    components: {ListHeader},
    data,
    methods,
    mounted,
    watch
}
